import { FC, Fragment, useEffect, useState } from 'react'
import { Outlet, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { getQuiz } from 'store/quiz/quizAsync';
// Actions
import { setQuiz } from 'store/quiz/quizSlice';
// Selectors
import { selectResultId, selectUserId } from 'store/auth/authSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
// Services
import StorageService from 'services/Storage.service';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
import Snackbar from 'components/Snackbar';
// i18next
import { getSearchParam } from 'utilities/Utilities';
import i18n from 'i18n';
import AppLoader from 'components/AppLoader';

const QuizRootPage:FC = () => {
  const { t } = useTranslation('common');
  const { slug } = useParams<{ slug:string }>();
  const { search } = window.location;

  const hasHash = getSearchParam(search, 'hasHash');

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:any = useAppSelector(selectQuiz);
  const resultId:string | null = useAppSelector(selectResultId);
  const userId:string | null = useAppSelector(selectUserId);

  const navigateTo = useNavigateTo();

  const [ loaded, setLoaded ] = useState<boolean | undefined>(undefined);
  const [ quizInitialized, setQuizInitialized ] = useState(false);

  useEffect(() => {
    if ( !hasHash ) setLoaded(true);
    window.addEventListener('message', onReceiveMessage, false);

    return () => {
      window.removeEventListener('message', onReceiveMessage, false);
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if ( loaded ){
      if ( StorageService.getQuiz() ){
        dispatch(setQuiz(StorageService.getQuiz()));
      } else {
        dispatch(getQuiz((slug as string)));
      }
    }
    // eslint-disable-next-line
  }, [loaded]);

  useEffect(() => {
    if ( quiz && quiz._id ){
      // Set default primary
      document.documentElement.style.setProperty('--primaryColor', quiz.primaryColor);
      document.documentElement.style.setProperty('--secondaryColor', quiz.secondaryColor);
      document.documentElement.style.setProperty('--tertiaryColor', quiz.tertiaryColor);
      document.documentElement.style.setProperty('--primaryFont', quiz.primaryFont);
      if ( quiz.wallpaperImage ){
        document.body.style.backgroundImage = `url(${quiz.wallpaperImage})`;
      }
      if ( quiz.applyPrimaryColorToProgressBar ){
        document.documentElement.style.setProperty('--progressColor', quiz.primaryColor);
      }
      document.documentElement.style.setProperty('--countdownTextColor', quiz.countDownTextColor);

      i18n.changeLanguage(quiz.language);

      if ( resultId ){
        if ( userId ){
          navigateTo('post-quiz');
        } else {
          navigateTo('register');
        }
      }

      setQuizInitialized(true);
    }
    // eslint-disable-next-line
  }, [quiz]);

  const onReceiveMessage = (event:any) => {
    const { action, quizHash } = event.data;
    if ( action === 'preview' && quizHash ){
      StorageService.setQuiz(quizHash);
      setLoaded(true);
    }
  }

  if ( typeof quiz === 'undefined' ) return <h1>{t('quiz.quizNotFound')}</h1>;
  // if ( quiz === null || !quizInitialized ) return <h1>{`${t('quiz.quizLoading')} ...`}</h1>;
  if ( quiz === null || !quizInitialized ) return <AppLoader />;
  return (
    <Fragment>
      <Outlet />
      <Snackbar />
    </Fragment>
  );
}

export default QuizRootPage;
